import { render } from "./number.vue?vue&type=template&id=383e8f10&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"

import "./number.vue?vue&type=style&index=0&id=383e8f10&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383e8f10"]])

export default __exports__